module.exports = __webpack_public_path__ + "static/media/uthealth-mcgovern-logo.6d0012df.svg";